import { useAppSelector } from '../hooks'

export const useThemeSelector = () => useAppSelector((state) => state.themes.theme)
